import * as settingsActions from '../actions/settings';
import * as fetchingState from '../constants/fetchingState';
import * as settingsTypes from '../constants/settingTypes';
import * as weekDays from '../constants/weekDays';
import moment from 'moment';
import { getErrorMessage } from '../constants/errorCode';

export default function(settings, action) {

    const updateSettings = (newValues) => {
        if (action.settingsType === settingsTypes.schedule && newValues.data && newValues.data.length > 0) {
            const timeZoneOffset = new Date().getTimezoneOffset() / 60;
            newValues.data.forEach(d => {
                d.PickupStartTime = d.PickupStartTime ? moment(d.PickupStartTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : d.PickupStartTime;
                d.PickupEndTime = d.PickupEndTime ? moment(d.PickupEndTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : d.PickupEndTime;
                d.OffloadStartTime = d.OffloadStartTime ? moment(d.OffloadStartTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : d.OffloadStartTime;
                d.OffloadEndTime = d.OffloadEndTime ? moment(d.OffloadEndTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : d.OffloadEndTime;
            });
        }
        if (action.settingsType === settingsTypes.departments && newValues.data && newValues.data.length > 0) {
            const timeZoneOffset = new Date().getTimezoneOffset() / 60;

            newValues.data.forEach(d => {
                const days = weekDays.days
                days.forEach(day => {
            if (d[day.name] && d[day.name].StartTime != null && d[day.name].EndTime != null) {
                const startTimeComponents = d[day.name].StartTime.split(':');
                const endTimeComponents = d[day.name].EndTime.split(':');

                d[day.name].StartTime = moment()
                    .set('hour', Number(startTimeComponents[0]) - timeZoneOffset)
                    .set('minute', startTimeComponents[1])
                    .set('second', 0)
                    .format('HH:mm');

                d[day.name].EndTime = moment()
                    .set('hour', Number(endTimeComponents[0]) - timeZoneOffset)
                    .set('minute', endTimeComponents[1])
                    .set('second', 0)
                    .format('HH:mm');
            }
        });
                const x = d.GeoAddress 
                    ? d.GeoAddress.X ? d.GeoAddress.X : undefined 
                    : undefined;
                const y = d.GeoAddress 
                    ? d.GeoAddress.Y ? d.GeoAddress.Y : undefined 
                    : undefined;
                d.Coords = x != null && y != null ? `${y}, ${x}` : undefined;
                
            });
        }
        return {...settings,
        [action.settingsType]: {
            ...settings[action.settingsType],
            ...newValues
        }};
    };

    switch (action.type) {
        case settingsActions.GET_SETTINGS:
            {
                return updateSettings({ fetching: fetchingState.FETCHING, error: undefined });
            }
        case settingsActions.SUCCESS_GET_SETTINGS:
            {
                return updateSettings({ fetching: fetchingState.FETCHED, data: action.data, error: undefined });
            }
        case settingsActions.FAILURE_GET_SETTINGS:
            {
                return updateSettings({ fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) });
            }

        case settingsActions.UPDATE_SETTINGS:
            {
                return updateSettings({ updateFetching: fetchingState.FETCHING, updateError: undefined });
            }
        case settingsActions.SUCCESS_UPDATE_SETTINGS:
            {
                return updateSettings({ updateFetching: fetchingState.FETCHED, updateError: undefined, data: action.data || settings.data });
            }
        case settingsActions.FAILURE_UPDATE_SETTINGS:
            {
                return updateSettings({ updateFetching: fetchingState.FAILED, updateError: getErrorMessage(action.data.error) });
            }
        case settingsActions.CLEAR_UPDATE_SETTINGS:
            {
                return updateSettings({ updateFetching: fetchingState.INITIAL });
            }

        case settingsActions.DELETE_SETTINGS:
            {
                return updateSettings({ deleteFetching: fetchingState.FETCHING, error: undefined });
            }
        case settingsActions.SUCCESS_DELETE_SETTINGS:
            {
                return updateSettings({ deleteFetching: fetchingState.FETCHED, error: undefined, data: action.data || settings.data });
            }
        case settingsActions.FAILURE_DELETE_SETTINGS:
            {
                return updateSettings({ deleteFetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) });
            }
        case settingsActions.CLEAR_DELETE_SETTINGS:
            {
                return updateSettings({ deleteFetching: fetchingState.INITIAL });
            }
        case settingsActions.UPDATE_BANNER:
            {
                return updateSettings({ updateFetching: fetchingState.FETCHING, error: undefined });
            }
        case settingsActions.SUCCESS_UPDATE_BANNER:
            {
                return updateSettings({ updateFetching: fetchingState.FETCHED, error: undefined });
            }
        case settingsActions.FAILURE_UPDATE_BANNER:
            {
                return updateSettings({ updateFetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) });
            }
        case settingsActions.FETCH_PROMO_SETTINGS:
            {
                return updateSettings({ fetching: fetchingState.FETCHED, error: undefined })
            }

        default:
            return settings;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.js